import React, { useContext } from 'react';
import { Button } from 'baseui/button';
import { DataList, Loader, CustomModal, ModalContext } from 'commons-ui';
import useSettingsActions from '../../../../useSettingsActions';

import { LIST_ENTITY_NAMES } from '../../../../../../settingsV2Constant';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useFilter from './useFilter';
import { columnConfigs } from './listConfig';
import '../../../../style.css';

const UserList: React.FC<{}> = () => {
	const { modalConfig } = useContext(ModalContext);

	const { getActionHandler, getActionList } = useSettingsActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { showLoader, getUserData, setChangeFilter, forceUpdate } = useFilter();

	return (
		<>
			{showLoader && <Loader />}
			<div className='user-list-header'>
				{!modalConfig.isOpen && (
					<div className='user-list-user-wrapper'>
						<div className='user-list-user-label'>User:</div>
					</div>
				)}
				<Button
					kind='primary'
					size='compact'
					onClick={() => {
						setChangeFilter(true);
					}}>
					Change Filter
				</Button>
			</div>
			<DataList
				fetchData={getUserData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				rowHeight={50}
				entity={LIST_ENTITY_NAMES.BULK_PERMISSIONS}
				globalForceUpdate={forceUpdate}
				height='calc(100vh - 220px)'
				filterable={false}
			/>
			<CustomModal />
		</>
	);
};

export default UserList;
